import React from "react"
import { compose, withProps, lifecycle } from "recompose"
import { withScriptjs, withGoogleMap, GoogleMap, Marker } from "react-google-maps"



const AddressToMapComponent = compose(
  withProps({
    googleMapURL: 'https://maps.googleapis.com/maps/api/js?key=AIzaSyChSiXc1Cyprcrhw2Unu1e1jXKMf1Cx1qo&v=3.exp&libraries=geometry,drawing,places',
    //googleMapURL: "https://maps.googleapis.com/maps/api/js?v=3.exp&libraries=geometry,drawing,places",
    loadingElement: <div style={{ height: `100%` }} />,
    containerElement: <div style={{height: `100%`  }} />,
    mapElement: <div style={{ height: `100%` }} />,
  }),
  withScriptjs,
  withGoogleMap
)((props) =>
  <GoogleMap
    defaultZoom={11}
    defaultCenter={{ lat: 55.75,  lng:37.61 }}
    center={{ lat: Number.parseFloat(props.latitude), lng: Number.parseFloat(props.longitude) }}
    defaultOptions={{
      streetViewControl: false,
      scaleControl: false,
      mapTypeControl: false,
      panControl: false,
      zoomControl: false,
      rotateControl: false,
      fullscreenControl: false
    }}
  >
   {props.isMarkerShown && <Marker position={{ lat: Number.parseFloat(props.latitude), lng: Number.parseFloat(props.longitude) }} />}
  </GoogleMap>
)



class MyComponent extends React.PureComponent {
   
  constructor(props) {
    super(props);
    this.state = {
      address: this.props.address,
      lat: Number.parseFloat(this.props.latitude), 
      lng: Number.parseFloat(this.props.longitude),
      isMarkerShown: true,
      gotAddress: false
    }
  }
  
  componentDidMount() {

    // Geocode.fromAddress(this.state.address).then(
    //   response => {
    //     const { lat, lng } = response.results[0].geometry.location;
    //     if(!this.state.gotAddress){
    //         this.setState({
    //           lat: response.results[0].geometry.location.lat,
    //           lng: response.results[0].geometry.location.lng
    //         })
    //       }
    //     console.log(lat, lng);
    //   },
    //   error => {
    //     console.error(error);
    //   }
    // )
  }

  render() {
    return (
      <AddressToMapComponent
        isMarkerShown={this.state.isMarkerShown}
        latitude={this.state.lat}
        longitude={this.state.lng}
        onMarkerClick={this.handleMarkerClick}
      />

      
    )
  }
}

export default MyComponent 